// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
	AddToCartData,
	AddToCartErrors,
	AddToCartResponses,
	BeginCheckoutData,
	BeginCheckoutErrors,
	BeginCheckoutResponses,
	CreateData,
	CreateErrors,
	CreateResponses,
	GetCountriesData,
	GetCountriesResponses,
	GetOrderConfirmationPdfContentData,
	GetOrderConfirmationPdfContentErrors,
	GetOrderConfirmationPdfContentResponses,
	GetOrderConfirmationPdfData,
	GetOrderConfirmationPdfErrors,
	GetOrderConfirmationPdfResponses,
	GetOrderInfoData,
	GetOrderInfoErrors,
	GetOrderInfoResponses,
	GetOrdersPerCustomerData,
	GetOrdersPerCustomerErrors,
	GetOrdersPerCustomerResponses,
	GetOrderTotalData,
	GetOrderTotalErrors,
	GetOrderTotalResponses,
	GetProductPriceData,
	GetProductPriceErrors,
	GetProductPriceResponses,
	GetTranslationKeysData,
	GetTranslationKeysErrors,
	GetTranslationKeysResponses,
	HasValidSalesForceAccountData,
	HasValidSalesForceAccountErrors,
	HasValidSalesForceAccountResponses,
	HasValidUmbracoAccountData,
	HasValidUmbracoAccountErrors,
	HasValidUmbracoAccountResponses,
	PurchaseData,
	PurchaseErrors,
	PurchaseResponses,
	RegisterNewCustomerData,
	RegisterNewCustomerErrors,
	RegisterNewCustomerResponses,
	RemoveFromBasketData,
	RemoveFromBasketErrors,
	RemoveFromBasketResponses,
	ResetPasswordData,
	ResetPasswordErrors,
	ResetPasswordResponses,
	SearchData,
	SearchResponses,
	SendPasswordResetMailData,
	SendPasswordResetMailErrors,
	SendPasswordResetMailResponses,
	SetPasswordData,
	SetPasswordErrors,
	SetPasswordResponses,
	TriggerEmailVerificationData,
	TriggerEmailVerificationErrors,
	TriggerEmailVerificationResponses,
	UpdateBasketData,
	UpdateBasketErrors,
	UpdateBasketResponses,
	UpdateDeliveryInformationData,
	UpdateDeliveryInformationErrors,
	UpdateDeliveryInformationResponses,
	UpsertBasketItemData,
	UpsertBasketItemErrors,
	UpsertBasketItemResponses,
	ViewItemData,
	ViewItemErrors,
	ViewItemResponses,
} from "./types.gen";

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
	TData,
	ThrowOnError
> & {
	/**
	 * You can provide a client instance returned by `createClient()` instead of
	 * individual options. This might be also useful if you want to implement a
	 * custom client.
	 */
	client?: Client;
	/**
	 * You can pass arbitrary values through the `meta` object. This can be
	 * used to access values that aren't defined as part of the SDK function.
	 */
	meta?: Record<string, unknown>;
};

export class AccountService {
	public static registerNewCustomer<ThrowOnError extends boolean = false>(
		options?: Options<RegisterNewCustomerData, ThrowOnError>
	) {
		return (options?.client ?? client).post<RegisterNewCustomerResponses, RegisterNewCustomerErrors, ThrowOnError>({
			url: "/_esfn/api/Account/apply",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	public static getCountries<ThrowOnError extends boolean = false>(options?: Options<GetCountriesData, ThrowOnError>) {
		return (options?.client ?? client).get<GetCountriesResponses, unknown, ThrowOnError>({
			url: "/_esfn/api/Account/countries",
			...options,
		});
	}

	public static hasValidSalesForceAccount<ThrowOnError extends boolean = false>(
		options?: Options<HasValidSalesForceAccountData, ThrowOnError>
	) {
		return (options?.client ?? client).get<
			HasValidSalesForceAccountResponses,
			HasValidSalesForceAccountErrors,
			ThrowOnError
		>({ url: "/_esfn/api/Account/hasvalidsalesforceaccount", ...options });
	}

	public static hasValidUmbracoAccount<ThrowOnError extends boolean = false>(
		options?: Options<HasValidUmbracoAccountData, ThrowOnError>
	) {
		return (options?.client ?? client).get<HasValidUmbracoAccountResponses, HasValidUmbracoAccountErrors, ThrowOnError>(
			{ url: "/_esfn/api/Account/hasvalidumbracoaccount", ...options }
		);
	}

	public static setPassword<ThrowOnError extends boolean = false>(options?: Options<SetPasswordData, ThrowOnError>) {
		return (options?.client ?? client).post<SetPasswordResponses, SetPasswordErrors, ThrowOnError>({
			url: "/_esfn/api/Account/setpassword",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	public static triggerEmailVerification<ThrowOnError extends boolean = false>(
		options?: Options<TriggerEmailVerificationData, ThrowOnError>
	) {
		return (options?.client ?? client).post<
			TriggerEmailVerificationResponses,
			TriggerEmailVerificationErrors,
			ThrowOnError
		>({
			url: "/_esfn/api/Account/triggeremailverification",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}
}

export class BasketService {
	public static removeFromBasket<ThrowOnError extends boolean = false>(
		options?: Options<RemoveFromBasketData, ThrowOnError>
	) {
		return (options?.client ?? client).delete<RemoveFromBasketResponses, RemoveFromBasketErrors, ThrowOnError>({
			url: "/_esfn/api/Basket",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	public static updateBasket<ThrowOnError extends boolean = false>(options?: Options<UpdateBasketData, ThrowOnError>) {
		return (options?.client ?? client).post<UpdateBasketResponses, UpdateBasketErrors, ThrowOnError>({
			url: "/_esfn/api/Basket/UpdateBasket",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	public static upsertBasketItem<ThrowOnError extends boolean = false>(
		options?: Options<UpsertBasketItemData, ThrowOnError>
	) {
		return (options?.client ?? client).post<UpsertBasketItemResponses, UpsertBasketItemErrors, ThrowOnError>({
			url: "/_esfn/api/Basket/Upsert",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}
}

export class GoogleService {
	public static addToCart<ThrowOnError extends boolean = false>(options?: Options<AddToCartData, ThrowOnError>) {
		return (options?.client ?? client).post<AddToCartResponses, AddToCartErrors, ThrowOnError>({
			url: "/_esfn/api/GoogleTracking/AddToCart",
			...options,
		});
	}

	public static beginCheckout<ThrowOnError extends boolean = false>(
		options?: Options<BeginCheckoutData, ThrowOnError>
	) {
		return (options?.client ?? client).post<BeginCheckoutResponses, BeginCheckoutErrors, ThrowOnError>({
			url: "/_esfn/api/GoogleTracking/BeginCheckout",
			...options,
		});
	}

	public static purchase<ThrowOnError extends boolean = false>(options?: Options<PurchaseData, ThrowOnError>) {
		return (options?.client ?? client).post<PurchaseResponses, PurchaseErrors, ThrowOnError>({
			url: "/_esfn/api/GoogleTracking/Purchase",
			...options,
		});
	}

	public static viewItem<ThrowOnError extends boolean = false>(options?: Options<ViewItemData, ThrowOnError>) {
		return (options?.client ?? client).post<ViewItemResponses, ViewItemErrors, ThrowOnError>({
			url: "/_esfn/api/GoogleTracking/ViewItem",
			...options,
		});
	}
}

export class IntegrationService {
	public static getOrderConfirmationPdf<ThrowOnError extends boolean = false>(
		options?: Options<GetOrderConfirmationPdfData, ThrowOnError>
	) {
		return (options?.client ?? client).get<
			GetOrderConfirmationPdfResponses,
			GetOrderConfirmationPdfErrors,
			ThrowOnError
		>({ url: "/_esfn/api/Integration/orderconfirmation", ...options });
	}

	public static getOrderConfirmationPdfContent<ThrowOnError extends boolean = false>(
		options?: Options<GetOrderConfirmationPdfContentData, ThrowOnError>
	) {
		return (options?.client ?? client).get<
			GetOrderConfirmationPdfContentResponses,
			GetOrderConfirmationPdfContentErrors,
			ThrowOnError
		>({ url: "/_esfn/api/Integration/orderconfirmation/content", ...options });
	}

	public static getOrderInfo<ThrowOnError extends boolean = false>(options?: Options<GetOrderInfoData, ThrowOnError>) {
		return (options?.client ?? client).get<GetOrderInfoResponses, GetOrderInfoErrors, ThrowOnError>({
			url: "/_esfn/api/Integration/orderinfo",
			...options,
		});
	}

	public static getOrdersPerCustomer<ThrowOnError extends boolean = false>(
		options?: Options<GetOrdersPerCustomerData, ThrowOnError>
	) {
		return (options?.client ?? client).get<GetOrdersPerCustomerResponses, GetOrdersPerCustomerErrors, ThrowOnError>({
			url: "/_esfn/api/Integration/orders",
			...options,
		});
	}

	public static getOrderTotal<ThrowOnError extends boolean = false>(
		options?: Options<GetOrderTotalData, ThrowOnError>
	) {
		return (options?.client ?? client).post<GetOrderTotalResponses, GetOrderTotalErrors, ThrowOnError>({
			url: "/_esfn/api/Integration/ordertotal",
			...options,
		});
	}

	public static getProductPrice<ThrowOnError extends boolean = false>(
		options?: Options<GetProductPriceData, ThrowOnError>
	) {
		return (options?.client ?? client).get<GetProductPriceResponses, GetProductPriceErrors, ThrowOnError>({
			url: "/_esfn/api/Integration/productprice",
			...options,
		});
	}
}

export class OrderService {
	public static create<ThrowOnError extends boolean = false>(options?: Options<CreateData, ThrowOnError>) {
		return (options?.client ?? client).post<CreateResponses, CreateErrors, ThrowOnError>({
			url: "/_esfn/api/Order",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	public static updateDeliveryInformation<ThrowOnError extends boolean = false>(
		options?: Options<UpdateDeliveryInformationData, ThrowOnError>
	) {
		return (options?.client ?? client).post<
			UpdateDeliveryInformationResponses,
			UpdateDeliveryInformationErrors,
			ThrowOnError
		>({
			url: "/_esfn/api/Order/UpdateDeliveryInformation",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}
}

export class PasswordResetService {
	public static resetPassword<ThrowOnError extends boolean = false>(
		options?: Options<ResetPasswordData, ThrowOnError>
	) {
		return (options?.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
			url: "/_esfn/api/PasswordReset/resetpassword",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	public static sendPasswordResetMail<ThrowOnError extends boolean = false>(
		options?: Options<SendPasswordResetMailData, ThrowOnError>
	) {
		return (options?.client ?? client).post<SendPasswordResetMailResponses, SendPasswordResetMailErrors, ThrowOnError>({
			url: "/_esfn/api/PasswordReset/sendpasswordresetmail",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}
}

export class QuickSearchService {
	public static search<ThrowOnError extends boolean = false>(options?: Options<SearchData, ThrowOnError>) {
		return (options?.client ?? client).get<SearchResponses, unknown, ThrowOnError>({
			url: "/_esfn/api/QuickSearch",
			...options,
		});
	}
}

export class TranslationsService {
	public static getTranslationKeys<ThrowOnError extends boolean = false>(
		options?: Options<GetTranslationKeysData, ThrowOnError>
	) {
		return (options?.client ?? client).get<GetTranslationKeysResponses, GetTranslationKeysErrors, ThrowOnError>({
			url: "/_esfn/api/Translations/keys",
			...options,
		});
	}
}
